import WrapperLayout from 'components/Layout';
import Main from './Components/Main';
const VMCCampaignTool = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default VMCCampaignTool